module.exports = __webpack_public_path__ + "img/cloud.465e2a23.svg";